import { keepPreviousData, type UseQueryResult } from "@tanstack/react-query";

import { useLLMReportQuery } from "app/pages/digital-marketing/generative-ai/llm-tracker/shared/hooks/useLLMReportQuery";
import type { ILLMWidgetRequestParams } from "app/pages/digital-marketing/generative-ai/llm-tracker/shared/types";
import { DefaultFetchService } from "app/services/fetchService";

import type { FiltersData } from "../types";

const fetchService = DefaultFetchService.getInstance();

const fetchPromptsFiltersData = (params: ILLMWidgetRequestParams): Promise<FiltersData> =>
    fetchService.get<FiltersData>("/api/aiTracker/reports/promptsReport/PromptsTable/FiltersData", params);

export const useFiltersData = (
    params: ILLMWidgetRequestParams,
    options?: { enabled?: boolean },
): UseQueryResult<FiltersData> =>
    useLLMReportQuery<FiltersData, ILLMWidgetRequestParams>("promptsFiltersData", fetchPromptsFiltersData, params, {
        placeholderData: keepPreviousData,
        ...options,
    });
